<h6>Send commands to customer</h6>
<div class="row mt-4">
    <div class="col-md-6 right-border-line">
        <div class="form-row">
            <div class="col-md-10 mb-3">
                <label>Available commands</label>
                <select class="form-control" [(ngModel)]="selectedAvailableCommand">
                    <option *ngFor="let command of commands" [ngValue]="command">{{command.Name}}</option>
                </select>
            </div>
            <div class="col-md-2">
                <div class="mb-2">&nbsp;</div>
                <button type="button" class="btn btn-light form-control" (click)="onAddCommand()">Add</button>
            </div>
        </div>
        <div *ngIf="choosedCommands.length > 0" class="form-row">
            <div class="col-md-12">
                <label>Commands to send</label>
                <div class="list-group">
                    <a *ngFor="let command of choosedCommands; index as i"
                        class="list-group-item list-group-item-action" [ngClass]="{'active': selectedCommand === command}"
                        (click)="onCommandClick(i)">
                        {{command.Name}}
                        <div class="btn-group pull-right">
                            <button type="button" class="btn btn-light" (click)="onCommandDown(i)" tooltip="Move Down"><span
                                    class="fa fa-arrow-down"></span></button>
                            <button type="button" class="btn btn-light" (click)="onCommandUp(i)" tooltip="Move Up"><span
                                    class="fa fa-arrow-up"></span></button>
                            <button type="button" class="btn btn-light text-danger" (click)="onCommandRemove(i)" tooltip="Remove"><span
                                    class="fa fa-window-close"></span></button>
                        </div>
                    </a>
                </div>
                <label class="mt-3">Additional recipients</label>
                <input class="form-control" [(ngModel)]="additionalRecipients" />
                <button type="button" class="btn btn-light pull-right mt-3" (click)="onSend()">Send</button>
            </div>
        </div>
    </div>
    <div class="col-md-6" *ngIf="selectedCommand">
        <label>Command arguments</label>
        <div *ngFor="let param of selectedCommand.Params" class="form-row">
            <div class="col-md-12 mb-3">
                <label>{{param.Name}}</label>
                <input *ngIf="param.Type === 'string' && param.Options === undefined" class="form-control" [required]="param.Required" [(ngModel)]="param.Value" />
                <select *ngIf="param.Type === 'string' && param.Options" class="form-control" [(ngModel)]="param.Value">
                    <option *ngFor="let option of param.Options" [ngValue]="option">{{option}}</option>
                </select>
                <div *ngIf="param.Type === 'file'" class="custom-file">
                    <input type="file" class="custom-file-input" id="customFile" (change)="onFileChange($event, param)">
                    <label class="custom-file-label" for="customFile">{{param.file ? param.file.name : 'Select file'}}</label>
                </div>
                <!-- <input *ngIf="param.Type === 'file'" class="form-control" type="file" [required]="param.Required" [(ngModel)]="param.Value" /> -->
            </div>
        </div>

    </div>
</div>